import useResponsive from '@parsina/framework/clinical/src/hooks/useResponsive';
import EncountersWeb from './Encounters.web';
import EncountersMobile from './Encounters.mobile';

// DESIGN-CONCEPT-MOBILE v2 §1.1: the two surfaces are independent render trees
// over one shared logic layer (`Encounters.shared`), not a responsive tier of
// the desktop table.
//
// Until now there was no second tree at all — `/encounters` served the
// six-column table to a phone, and the PWA manifest had a home-screen shortcut
// pointing straight at it.
const EncountersScreen = () => {
  const { isMobile } = useResponsive();
  return isMobile ? <EncountersMobile /> : <EncountersWeb />;
};

export default EncountersScreen;
